import {
  resolveSupplierOnboardingStepId,
  type SupplierOnboardingStepId,
} from "~/pages/SupplierPortal/Onboarding/constants/supplierOnboardingSteps"

export const USER_ONBOARDING_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  BLOCKED: "BLOCKED",
} as const

export type UserOnboardingStatus =
  (typeof USER_ONBOARDING_STATUS)[keyof typeof USER_ONBOARDING_STATUS]

export type UserOnboardingApiState = Readonly<{
  status: UserOnboardingStatus
  currentStep: SupplierOnboardingStepId | null
}>

export type OnboardingGateOutcome = "skip" | "start" | "resume" | "block"

export type OnboardingEntryDecision = Readonly<{
  outcome: OnboardingGateOutcome
  stepId?: SupplierOnboardingStepId
}>

export type ResolveOnboardingEntryDecisionInput = Readonly<{
  isEligible: boolean
  isOnboardingFeatureEnabled: boolean
  state: UserOnboardingApiState | null
}>

export const resolveOnboardingEntryDecision = ({
  isEligible,
  isOnboardingFeatureEnabled,
  state,
}: ResolveOnboardingEntryDecisionInput): OnboardingEntryDecision => {
  if (!isEligible || !isOnboardingFeatureEnabled) {
    return { outcome: "skip" }
  }

  if (state === null) {
    return { outcome: "start" }
  }

  switch (state.status) {
    case USER_ONBOARDING_STATUS.IN_PROGRESS:
      return {
        outcome: "resume",
        stepId: resolveSupplierOnboardingStepId(state.currentStep),
      }
    case USER_ONBOARDING_STATUS.COMPLETED:
      return { outcome: "skip" }
    case USER_ONBOARDING_STATUS.BLOCKED:
      return { outcome: "block" }
    default:
      return { outcome: "skip" }
  }
}
